import { useState } from 'react'
import './portfolio.css'
import Project from './Project'
import ProjectModal from './ProjectModal'
import data from './data'

const Portfolio = () => {
  const [selectedProject, setSelectedProject] = useState(null)

  return (
    <section id="portfolio">
      <h2>Projects</h2>
      <br />
      <p>
        Some of the projects I worked on during my free time.
      </p>
      <div className="container portfolio__container">
        {data.map(project => (
          <Project
            key={project.id}
            project={project}
            onExpand={() => setSelectedProject(project)}
          />
        ))}
      </div>
      <ProjectModal project={selectedProject} onClose={() => setSelectedProject(null)} />
    </section>
  )
}

export default Portfolio